'use strict';

var _ = require('lodash');
var gridColumns = require('../config/fare-change-grid-columns.json');
var gridDataFields = require('../config/fare-change-grid-data-fields.json');
var FareChangeGridConfigurationService = function FareChangeGridConfigurationService($q, heatmapService, hepService) {
  function getHeatMapCellColor(rowId, datafield, value) {
    var rangesToCellColor = heatmapService.getHeatMapColor();
    var cellClass = 'heatMapRange1';
    var parsedValue = removeThousandSeparator(value);
    _.forOwn(rangesToCellColor, function (heatMapClass, minRange) {
      if (parsedValue >= parseInt(minRange)) {
        cellClass = heatMapClass.cssCellClassName;
      }
    });
    return cellClass;
  }
  function removeThousandSeparator(value) {
    return parseInt(value.replace(/,/g, ''), 10);
  }
  function transformDataFieldToColumnsConfig(dataFieldConfig) {
    return {
      datafield: dataFieldConfig.name,
      text: dataFieldConfig.text,
      cellsformat: 'n',
      width: dataFieldConfig.width
    };
  }
  function prepareDataField(dataFieldName) {
    return {
      name: dataFieldName
    };
  }
  function addConfigToColumn(column) {
    column.cellclassname = getHeatMapCellColor;
  }
  function prepareColumn(dataFieldConfig, initialColumns) {
    var columnConfig = transformDataFieldToColumnsConfig(dataFieldConfig);
    var column = _.assign(_.cloneDeep(initialColumns), columnConfig);
    addConfigToColumn(column);
    return column;
  }
  function prepareConfig(dataFieldsConfig) {
    var columns = _.cloneDeep(gridColumns.columns);
    var initialColumns = _.find(columns, {
      datafield: 'tempColumn'
    });
    var dataFields = _.cloneDeep(gridDataFields.datafields);
    _.forEach(dataFieldsConfig, function (dataFieldConfig) {
      dataFields.push(prepareDataField(dataFieldConfig.name));
      columns.push(prepareColumn(dataFieldConfig, initialColumns));
    });
    _.remove(columns, {
      datafield: 'tempColumn'
    });
    return {
      datafields: dataFields,
      columns: columns
    };
  }
  function prepareGridConfig(aggregationMethod, snapshotDate) {
    var dataFieldsConfig = createDateFieldsConfig(aggregationMethod, snapshotDate);
    return prepareConfig(dataFieldsConfig);
  }
  function createDateFieldsConfig(aggregationMethod, snapshotDate) {
    return aggregationMethod === 'byMonth' ? createDataFieldsNamesByMonth(snapshotDate) : createDataFieldsNamesByDTD();
  }
  function createDataFieldsNamesByDTD() {
    var advancePurchasingDepartureDateRanges = hepService.getAdvancePurchasingDepartureDateRange();
    heatmapService.setCurrentRanges(advancePurchasingDepartureDateRanges);
    return _.transform(advancePurchasingDepartureDateRanges, function (result, range) {
      result.push({
        name: range,
        text: range,
        width: '10%'
      });
    }, []);
  }
  function createDataFieldsNamesByMonth(snapshotDate) {
    var dataFieldsConfig = [];
    var loopDate = snapshotDate;
    for (var i = 0; i < 12; i++) {
      dataFieldsConfig.push({
        name: loopDate.format('MMMYY'),
        text: loopDate.format('MMM\'YY'),
        width: '5.01%'
      });
      loopDate = loopDate.add(1, 'month');
    }
    heatmapService.setCurrentRanges(_.map(dataFieldsConfig, 'name'));
    return dataFieldsConfig;
  }
  return {
    getHeatMapCellColor: getHeatMapCellColor,
    prepareGridConfig: prepareGridConfig
  };
};
FareChangeGridConfigurationService.$inject = ['$q', 'FareChangeGridMetricHeatmapService', 'HepService'];
module.exports = FareChangeGridConfigurationService;